export default {
  warning:
    "Ce restaurant n'est associé à aucune marque. Pour que le système fonctionne correctement, le restaurant doit appartenir à une marque. Veuillez ajouter ce restaurant à une marque.",
  cta: 'Aller aux marques',
};
